import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import FormLayoutTwo from '../../../../Core/Layout/FormLayoutTwo'
import Button from '../../../../Core/Button/Button'
import ApiResponseBox from '../../../../Components/ApiResponseBox'
import { usePageState } from '../../../../Hook/usePageState'
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch'
import Date from '../../../../Core/Fields/Floating/Date'
import Header from '../../../../Components/Header'
import GetIcon from '../../../../utils/Icon'
import ConfigureColumns from '../../../Outbound/SalesInvoice/Create-Sales-Invoice/Components/ConfigureColumns'

import { AiOutlinePrinter } from 'react-icons/ai'


const AddQualityReview = () => {
  const navigate = useNavigate()
  const [error, setError] = useState('')
  const [ptype, setptype] = useState('Error')
  const [showError, setShowError] = useState(false)

  const pageStateDefault = {
    tab: 1,
    goal: '',
    reviewDate: '',
    status: ''
  }

  const [pageState, setPageState] = usePageState('Add Quality Review', pageStateDefault)
  const [reviewRows, setReviewRows] = useState([
    { objective: '', target: '', uom: '', status: 'Open', review: '' }
  ])

  const initialColumns = [
    { key: 'checkbox', name: '', width: '4%', selected: true },
    { key: 'slno', name: 'Sl No.', width: '8%', selected: true },
    { key: 'objective', name: 'Objective', selected: true },
    { key: 'target', name: 'Target', selected: true },
    { key: 'uom', name: 'UOM', selected: true },
    { key: 'status', name: 'Status', selected: true },
    { key: 'review', name: 'Review', selected: true },

    { key: 'setting', name: 'Setting', width: '6%', selected: true }
  ]

  const [columns, setColumns] = useState(initialColumns)
  const [showColumnConfig, setShowColumnConfig] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [editingRow, setEditingRow] = useState(null)
  const [selectedRows, setSelectedRows] = useState([])
  const [selectAll, setSelectAll] = useState(false)
  const visibleColumns = columns.filter((column) => column.selected)

  const { tab, goal, reviewDate, status } = pageState

  const goalOptions = [
    { label: "+ Create New Quality Goal" },
    { label: 'Qty-goal-01', value: 'Qty-goal-01' },
    { label: 'Qty-goal-02', value: 'Qty-goal-02' },
    { label: 'Qty-goal-03', value: 'Qty-goal-03' }
  ]

  const statusOptions = [
    { label: 'Open', value: 'Open' },
    { label: 'Passed', value: 'Passed' },
    { label: 'Closed', value: 'Closed' }
  ]

  const handleInputChange = (field, value) => {
    setPageState({ ...pageState, [field]: value })
  }

  const handleReviewChange = (index, field, value) => {
    setReviewRows((prev) =>
      prev.map((row, idx) => (idx === index ? { ...row, [field]: value } : row))
    )
  }

  const handleAddReviewRow = () => {
    setReviewRows((prev) => [...prev, { objective: '', target: '', uom: '', status: 'Open', review: '' }])
  }

  const handleRemoveReviewRow = (index) => {
    setReviewRows((prev) => (prev.length === 1 ? prev : prev.filter((_, idx) => idx !== index)))
  }

  const handleDeleteSelectedRows = () => {
    setReviewRows((prev) => prev.filter((_, idx) => !selectedRows.includes(idx)))
    setSelectedRows([])

    
    setSelectAll(false)
  }

  const handleSaveColumns = (updatedColumns) => {
    setColumns(updatedColumns)
    setShowColumnConfig(false)
  }

  const handleEditRow = (index) => {
    setEditingRow({ ...reviewRows[index], index })
    setShowEditModal(true)
  }

  const handleSaveEdit = () => {
    const updatedRows = [...reviewRows]
    updatedRows[editingRow.index] = {
      objective: editingRow.objective,
      target: editingRow.target,
      uom: editingRow.uom,
      status: editingRow.status,
      review: editingRow.review
    }
    setReviewRows(updatedRows)
    setShowEditModal(false)
    setEditingRow(null)
  }

  const handleSelectAll = () => {
    const newSelectAll = !selectAll
    setSelectAll(newSelectAll)
    if (newSelectAll) {
      setSelectedRows(reviewRows.map((_, index) => index))
    } else {
      setSelectedRows([])
    }
  }

  const handleRowSelect = (index) => {
    setSelectedRows(prev => {
      const newSelected = prev.includes(index)
        ? prev.filter(i => i !== index)
        : [...prev, index]
      setSelectAll(newSelected.length === reviewRows.length)
      return newSelected
    })
  }

  const handleSubmit = async () => {
    console.log('Submitting:', { ...pageState, reviewRows })
    setError('Quality Review added successfully!')
    setptype('Success')
    setShowError(true)
    setTimeout(() => {
      navigate('/master/quality-review/quality-review-list')
    }, 3000)
  }

  const handleQualityAction = () => {
    navigate('/master/quality-review/quality-action-list')
  }

  
  const EditReviewModal = () => {
    if (!showEditModal || !editingRow) return null

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.4)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 2000
        }}
      >
        <div
          style={{
            width: "850px",
            maxHeight: "90vh",
            overflowY: "auto",
            background: "#fff",
            borderRadius: "8px",
            padding: "20px 24px",
            boxShadow: "0px 4px 18px rgba(0,0,0,0.25)"
          }}
        >
          {/* HEADER */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 style={{ fontWeight: 600, margin: 0 }}>Edit Item Details</h5>

            <div
              onClick={() => {
                setShowEditModal(false)
                setEditingRow(null)
              }}
              style={{ cursor: "pointer" }}
            >
              <GetIcon
                iconName="RxCross2"
                size={22}
              />
            </div>
          </div>

          {/* FORM FIELDS */}
          <div className="row" style={{ rowGap: "18px" }}>
            <div className="col-md-6">
              <label className="form-label fw-semibold">Objective</label>
              <input
                className="form-control"
                value={editingRow.objective}
                onChange={(e) =>
                  setEditingRow({ ...editingRow, objective: e.target.value })
                }
              />
            </div>

            <div className="col-md-6">
              <label className="form-label fw-semibold">Target</label>
              <input
                className="form-control"
                value={editingRow.target}
                onChange={(e) =>
                  setEditingRow({ ...editingRow, target: e.target.value })
                }
              />
            </div>

            <div className="col-md-6">
              <label className="form-label fw-semibold">UOM</label>
              <input
                className="form-control"
                value={editingRow.uom}
                onChange={(e) =>
                  setEditingRow({ ...editingRow, uom: e.target.value })
                }
              />
            </div>

            <div className="col-md-6">
              <label className="form-label fw-semibold">Status</label>
              <select
                className="form-select"
                value={editingRow.status}
                onChange={(e) =>
                  setEditingRow({ ...editingRow, status: e.target.value })
                }
              >
                {statusOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-12">
              <label className="form-label fw-semibold">Review</label>
              <input
                className="form-control"
                value={editingRow.review}
                onChange={(e) =>
                  setEditingRow({ ...editingRow, review: e.target.value })
                }
              />
            </div>
          </div>

          {/* FOOTER */}
          <div className="d-flex justify-content-end mt-4">
            <Button
              className="custom-btn-00989"
              iconName="LuSave"
              iconSize={12}
              onClick={handleSaveEdit}
              style={{ height: "32px", padding: "0px 14px" }}
            >
              Save Changes
            </Button>
          </div>
        </div>
      </div>
    )
  }

  // ==============================
  // PAGE RENDER
  // ==============================
  return (
    <>
      <Helmet>
        <title>Add Quality Review</title>
      </Helmet>

      <Header />

      <FormLayoutTwo
        title="New Quality Review"
        breadcrumbs={[
          { label: 'Quality Review' },
          { label: 'Quality Review List', url: '/master/quality-review/quality-review-list' },
        ]}
        status="New"  
        actionButtons={
        
          
        
          <>
            
            <Button
              className="custom-btn-00989"
              iconName="LuFilePlus2"
              style={{ gap: '2px', height: '28px' }}
              onClick={handleSubmit}
              iconSize={12}
            >
              Save
            </Button>
            <Button
              className="custom-btn-00989"
              style={{ gap: '2px', height: '28px' }}
            >
            
            </Button>
          </>
        }
      >

        {/* ======================= */}
        {/* EDIT MODAL HERE */}
        {/* ======================= */}
        {showEditModal && <EditReviewModal />}

        {/* REST OF YOUR UI */}
        <div className="" style={{ width: '100%', backgroundColor: '#fff', flexGrow: '1' }}>
          <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
            <div className="d-flex justify-content-between align-items-end">
              <ul className="nav nav-tabs" style={{ color: 'white', border: 'none', marginLeft: '16px' }}>
                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                  <a
                    className={
                      tab === 1
                        ? 'removeborder234 nav-link active-tab-custom text-white border-radius-top-corner'
                        : 'removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner'
                    }
                    onClick={() => setPageState({ ...pageState, tab: 1 })}
                    href="javascript:void(0);"
                  >
                    General Details
                  </a>
                </li>
              </ul>

              <div
                className="d-flex align-items-center mb-2 px-3"
                style={{ gap: '6px', fontSize: '12px', color: '#4B002B', cursor: 'pointer' }}
              >
                <GetIcon iconName="CgAttachment" size={14} color="#4B002B" />
                <span className="fw-semibold">Attachments</span>
              </div>
            </div>
          </div>

          {/* FORM CONTENT */}
          <div className="px-4 py-4">
            {tab === 1 && (
              <>
                <div className="mb-3" style={{ display: 'flex', gap: '20px' }}>
                  <div className="col-md-9 px-0">

                    <div
                      style={{
                        backgroundColor: '#EBE6FA',
                        borderRadius: '6px',
                        padding: '16px',
                        minHeight: '120px'
                      }}
                    >
                      <p className="mb-3" style={{ fontSize: '16px', fontWeight: 600 }}>Details</p>

                      <div className="d-flex flex-wrap" style={{ gap: '15px' }}>
                        <div style={{ flex: 1, minWidth: '220px' }}>
                          <SelectSearch
                            label="Goal"
                            placeholder="Select Goal"
                            value={goal}
                            onChange={(value) => handleInputChange('goal', value)}
                            list={goalOptions}
                            getOptionLabel={(item) => item.label}
                            getOptionValue={(item) => item.value}

                          />
                        </div>

                        <div style={{ flex: 1, minWidth: '220px' }}>
                          <Date
                            label="Date"
                            value={reviewDate}
                            onChange={(e) => handleInputChange('reviewDate', e.target.value)}
                          />
                        </div>

                        <div style={{ flex: 1, minWidth: '220px' }}>
                          <SelectSearch
                            label="Status"
                            placeholder="Select Status"
                            value={status}
                            onChange={(value) => handleInputChange('status', value)}
                            list={statusOptions}
                            getOptionLabel={(item) => item.label}
                            getOptionValue={(item) => item.value}
                          />
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                {/* TABLE SECTION */}
                <div
                  className="mb-3"
                  style={{
                    border: '1px solid #DBDBDB',
                    borderRadius: '6px',
                    padding: '16px',
                    backgroundColor: '#fff'
                  }}
                >
                  <p className="mb-3" style={{ fontSize: '16px', fontWeight: 600 }}>Review</p>

                  <div className="table-responsive">
                    <table className="table table-bordered mb-0">
                      <thead>
                        <tr>
                          {visibleColumns.map((column,index) => (
                            <th key={column.key} style={{ width: column.width || 'auto' }}>
                              {column.key === 'checkbox' ? (
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={selectAll}
                                  onChange={handleSelectAll}
                                />
                              ) : column.key === 'setting' ? (
                                <div
                                  onClick={() => setShowColumnConfig(true)}
                                  style={{ cursor: 'pointer', textAlign: 'center' }}
                                >
                                  <GetIcon iconName="PiSlidersHorizontalBold" size={14} />
                                </div>
                              ) : column.name}
                            </th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {reviewRows.map((row, index) => (
                          <tr key={index}>
                            {visibleColumns.map((column) => {
                              if (column.key === 'checkbox') {
                                return (
                                  <td className="text-center">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      checked={selectedRows.includes(index)}
                                      onChange={() => handleRowSelect(index)}
                                    />
                                  </td>
                                )
                              }

                              if (column.key === "slno") {
                               return <td className="text-center">{index + 1}</td>
                              }
                              

                              if (column.key === 'objective' || column.key === 'target') {
                                return (
                                  <td>
                                    <input
                                      className="form-control border-0 shadow-none"
                                      type="text"
                                      value={row[column.key]}
                                      onChange={(e) => handleReviewChange(index, column.key, e.target.value)}
                                      placeholder={column.name}
                                      style={{ background: 'transparent' }}
                                    />
                                  </td>
                                )
                              }

                              if (column.key === 'uom') {
                                return (
                                  <td>
                                    <input
                                      className="form-control border-0 shadow-none"
                                      value={row.uom}
                                      placeholder="UOM"
                                      onChange={(e) => handleReviewChange(index, 'uom', e.target.value)}
                                      style={{ background: 'transparent' }}
                                    />
                                  </td>
                                )
                              }

                              if (column.key === 'status') {
                                return (
                                  <td>
                                    <select
                                      className="form-select border-0 shadow-none"
                                      value={row.status}
                                      onChange={(e) => handleReviewChange(index, 'status', e.target.value)}
                                      style={{ background: 'transparent' }}
                                    >
                                      {statusOptions.map((opt) => (
                                        <option key={opt.value} value={opt.value}>
                                          {opt.label}
                                        </option>
                                      ))}
                                    </select>
                                  </td>
                                )
                              }

                              if (column.key === 'review') {
                                return (
                                  <td>
                                    <input
                                      className="form-control border-0 shadow-none"
                                      placeholder="Review"
                                      value={row.review}
                                      onChange={(e) => handleReviewChange(index, 'review', e.target.value)}
                                      style={{ background: 'transparent' }}
                                    />
                                  </td>
                                )
                              }

                              if (column.key === 'setting') {
                                return (
                                  <td className="text-center">
                                    <div
                                      onClick={() => handleEditRow(index)}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      <GetIcon
                                        iconName="MdOutlineEdit"
                                        size={14}
                                        style={{ color: '#82868C' }}
                                      />
                                    </div>
                                  </td>
                                )
                              }

                              return null
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div className="d-flex" style={{ gap: '4px' }}>
                      {selectedRows.length > 0 && (
                        <Button
                          style={{
                            backgroundColor: "#FF5969",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px"
                          }}
                          className="btn-danger"
                          onClick={handleDeleteSelectedRows}
                        >
                          <GetIcon
                          iconName="MdDeleteOutline" size={12} />
                          Delete
                        </Button>
                      )}
                      <Button
                        className="Addrowdesign"
                        iconName="FiPlus"
                        iconSize={12}
                        onClick={handleAddReviewRow}
                        iconWrapperStyle={{
                          backgroundColor: '#F6D593',
                          padding: '1px',
                          display: 'flex'
                        }}
                      >
                        Add Row
                      </Button>
                    </div>

                    <span style={{ fontSize: '12px', color: '#270B79' }}>
                      Showing {reviewRows.length ? 1 : 0} to {reviewRows.length} of {reviewRows.length} entries
                    </span>
                  </div>

                  <ConfigureColumns
                    show={showColumnConfig}
                    onClose={() => setShowColumnConfig(false)}
                    onSave={handleSaveColumns}
                    initialFields={columns}
                    title="Quality Review"
                    type="Quality Review"
                  />
                </div>
              </>
            )}
          </div>
        </div>

        <ApiResponseBox
          poptype={ptype}
          show={showError}
          errorMessage={error}
          onClose={() => setShowError(false)}
        />
      </FormLayoutTwo>
    </>
  )
}

export default AddQualityReview

